// extracted by mini-css-extract-plugin
export default {"panel":"LogoPanel_panel__Qdznd","logo":"LogoPanel_logo__XXXFv","subheading":"LogoPanel_subheading__LWDfp"};